import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import {
  HomologatedIntegrationStatus,
  HomologatedModelIntegrationCode,
} from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseHomologatedModelIntegrationCodesProps<T> {
  filters?: {
    search?: string
    manufacturer_id?: string
    integration_status?: HomologatedIntegrationStatus | ''
    equipment_model_id?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useHomologatedModelIntegrationCodes = <T,>({
  filters: { search = '', manufacturer_id, integration_status, equipment_model_id, page } = {},
  mapper = Mapper.default<T>(),
}: UseHomologatedModelIntegrationCodesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: [
      'modelIntegrationCodes',
      'homologated',
      search,
      manufacturer_id,
      integration_status,
      equipment_model_id,
      page,
    ],
    queryFn: () =>
      privateAxios.get('/equipment_models/integration_codes', {
        params: {
          search: search || undefined,
          'q[manufacturer_id_eq]': manufacturer_id || undefined,
          'q[integration_status_eq]': integration_status || undefined,
          'q[equipment_model_id_eq]': equipment_model_id || undefined,
          page,
        },
      }),
    select: (response: { data: { data: HomologatedModelIntegrationCode[]; meta: MetaResponse } }) => ({
      data: mapper(response?.data?.data),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
